import type { CameraConfiguration, PageableContent, PageableContentAPI, UpdateCameraConfigurationRequest, UpdateCameraSpeedLimit } from '@cobliteam/common-types';
import type { CameraConfigurationAPI, UpdateCameraConfigurationRequestAPI, UpdateCameraSpeedLimitRequestAPI } from './definitions/APITypes';

export const toCameraConfiguration = (cameraConfigurationApi: CameraConfigurationAPI): CameraConfiguration => ({
  deviceId: cameraConfigurationApi.device_id,
  audioStatus: cameraConfigurationApi.audio_status,
  updatedAt: cameraConfigurationApi.updated_at,
  speedLimitWarningInKmph: cameraConfigurationApi.speed_limit_warning_in_kmph,
});

export const toCameraConfigurationPage = (page: PageableContentAPI<CameraConfigurationAPI>): PageableContent<CameraConfiguration> => ({
  content: page.content.map(toCameraConfiguration),
  last: page.last,
  totalPages: page.total_pages,
  totalElements: page.total_elements,
  numberOfElements: page.number_of_elements,
  number: page.number,
  size: page.size,
  first: page.first,
  empty: page.empty,
});

export const toUpdateCameraConfigurationRequestAPI = (request: UpdateCameraConfigurationRequest[]): UpdateCameraConfigurationRequestAPI[] =>
  request.map((device) => ({
    device_id: device.deviceId,
    audio_status: device.audioStatus,
    speed_limit_warning_in_kmph: device.speedLimitWarningInKmph,
    duty_type: device.dutyType,
  }));

export const toUpdateSpeedLimitRequestAPI = (request: UpdateCameraSpeedLimit): UpdateCameraSpeedLimitRequestAPI => ({
  device_id: request.deviceId,
  speed_limit_warning_in_kmph: request.speedLimitWarningInKmph,
  duty_type: request.dutyType,
});
